import React, {Component,} from 'react'

import getDisplayName from '../getDisplayName'
import getGraphQLError from './getGraphQLError'




















export const formatError = (
  rawError
) => {
  const firstError = Array.isArray(rawError) ? rawError[0] : rawError
  if (typeof firstError === 'object' && 'message' in firstError) {
    return firstError.message
  }
  return firstError
}

// Serves as a lightweight alternative for a form library, best used for single-field forms
const withMutationProps = (
  ComposedComponent
) => {
  class MutationProps extends Component {constructor(...args) { super(...args); MutationProps.prototype.__init.call(this);MutationProps.prototype.__init2.call(this);MutationProps.prototype.__init3.call(this);MutationProps.prototype.__init4.call(this);MutationProps.prototype.__init5.call(this);MutationProps.prototype.__init6.call(this); }
    static __initStatic() {this.displayName = `WithMutationProps(${getDisplayName(ComposedComponent)})`}

    __init() {this._mounted = false}

    __init2() {this.state = {
      submitting: false,
      error: undefined,
      dirty: false
    }}

    componentDidMount() {
      this._mounted = true
    }

    componentWillUnmount() {
      this._mounted = false
    }

    __init3() {this.onCompleted = (res, errors) => {
      const error = getGraphQLError(res, errors)
      if (this._mounted) {
        this.setState({
          submitting: false,
          error: formatError(error)
        })
      }
      return error
    }}

    __init4() {this.onError = (rawError) => {
      if (this._mounted) {
        this.setState({
          submitting: false,
          error: formatError(rawError)
        })
      }
    }}

    __init5() {this.setDirty = () => {
      if (this._mounted && !this.state.dirty) {
        this.setState({dirty: true})
      }
    }}

    __init6() {this.submitMutation = () => {
      if (this._mounted) {
        this.setState({
          dirty: false,
          submitting: true
        })
      }
    }}

    render() {
      const {dirty, error, submitting} = this.state
      // https://github.com/Microsoft/TypeScript/issues/10727
      const {forwardedRef, ...props} = this.props 
      return (
        React.createElement(ComposedComponent, {
          dirty: dirty,
          error: error,
          setDirty: this.setDirty,
          submitting: submitting,
          submitMutation: this.submitMutation,
          onCompleted: this.onCompleted,
          onError: this.onError,
          ref: forwardedRef,
          ...props,}
        )
      )
    }
  } MutationProps.__initStatic();
  return React.forwardRef((props, ref) => (
    React.createElement(MutationProps, { ...props, forwardedRef: ref,} )
  ))
}

export default withMutationProps
